export default __webpack_public_path__ + "static/media/topborderring.abe14f09.png";